import React from 'react';
import { ModalContent, ModalFooter } from 'fronton-react';
import { ButtonWithGAClickButton, ModalHeader, Typography } from 'common/components';
import { ENTRANCE_DOORS_ELEMENT_BLOCK } from '../../../../entrance-doors-constants';

type VestibuleDoorProps = {
  onConsultationSignupBtnClick: () => void;
};

export const VestibuleDoor = ({ onConsultationSignupBtnClick }: VestibuleDoorProps) => (
  <>
    <ModalHeader title="Прочные двери в&nbsp;тамбур" />
    <ModalContent>
      <Typography variant="m" size="body_long">
        Если вы&nbsp;и&nbsp;ваши соседи хотите повысить уровень безопасности и&nbsp;теплоизоляции
        на&nbsp;лестничной клетке, мы&nbsp;изготовим специальную дверь из&nbsp;прочных и&nbsp;надёжных
        материалов.
      </Typography>
    </ModalContent>
    <ModalFooter>
      <ButtonWithGAClickButton
        elementBlock={ENTRANCE_DOORS_ELEMENT_BLOCK}
        elementText="Оставить заявку"
        elementName="Прочные двери в тамбур"
        onClick={onConsultationSignupBtnClick}
        wide>
        Оставить заявку
      </ButtonWithGAClickButton>
    </ModalFooter>
  </>
);
